/**
 * Symulator rat — logika kalkulatora na karcie produktu.
 *
 * Ceny wchodzą z Shopify w groszach i tylko tu są przeliczane na złotówki.
 * Modal (ESC, klik w tło, pułapka fokusu) obsługuje modal-dialog z Dawn.
 */
(function () {
  'use strict';

  /** Zaokrąglenie matematyczne do dwóch miejsc (połówka w górę). */
  function roundMoney(value) {
    var cents = Math.round((value + Number.EPSILON) * 100);
    var result = cents / 100;
    return Object.is(result, -0) ? 0 : result;
  }

  /** Kwota po polsku: "1099,50 zł", "200 zł". Grosze tylko gdy niezerowe. */
  function formatPLN(value) {
    var rounded = roundMoney(value);
    var hasGrosze = Math.round(rounded * 100) % 100 !== 0;
    var formatted = new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: hasGrosze ? 2 : 0,
      maximumFractionDigits: hasGrosze ? 2 : 0
    }).format(rounded);
    // Zapis \u00A0 zamiast niewidocznej spacji nierozdzielającej: dosłowny znak
    // ginie przy kopiowaniu przez schowek i kwoty zaczynają się łamać na końcu
    // linii. Klasa poniżej łapie zwykłą spację, wąską i nierozdzielającą.
    return formatted.replace(/[\s\u202F\u00A0]/g, '\u00A0') + '\u00A0zł';
  }

  /** Rata miesięczna: przy zerowej stopie zwykły podział, inaczej annuitet. */
  function monthlyPayment(credit, months, annualRate) {
    if (months <= 0) return 0;
    if (!annualRate) return roundMoney(credit / months);
    var r = annualRate / 12;
    return roundMoney((credit * r) / (1 - Math.pow(1 + r, -months)));
  }

  function addDays(baseDate, days) {
    var d = new Date(baseDate.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    return pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.' + date.getFullYear();
  }

  function toMonths(list) {
    return (list || []).map(function (v) { return parseInt(String(v).trim(), 10); })
      .filter(function (v) { return !isNaN(v) && v > 0; });
  }

  function Kalkulator(root) {
    this.root = root;
    this.cfg = JSON.parse(root.dataset.settings);
    this.cfg.zeroMonths = toMonths(this.cfg.zeroMonths);
    this.cfg.lowMonths = toMonths(this.cfg.lowMonths);
    this.sectionId = root.dataset.sectionId;
    this.priceCents = parseInt(root.dataset.price, 10) || 0;

    this.warianty = [{ id: 'zero', label: this.cfg.zeroLabel, months: this.cfg.zeroMonths, rate: 0, note: '' }];
    if (this.cfg.showLowTab && this.cfg.lowMonths.length) {
      this.warianty.push({
        id: 'low',
        label: this.cfg.lowLabel,
        months: this.cfg.lowMonths,
        rate: this.cfg.lowAnnualRate,
        note: this.cfg.lowNote || ''
      });
    }

    this.wariantIdx = 0;
    // Domyślnie najdłuższy okres — daje najniższą ratę, czyli to, co obiecuje przycisk.
    this.monthsIdx = Math.max(0, this.warianty[0].months.length - 1);

    // modal-dialog przenosi okno do <body> zaraz po sparsowaniu, więc zawartości
    // modala NIE MA już wewnątrz bloku — trzeba jej szukać po identyfikatorze.
    this.modal = document.getElementById(root.dataset.modalId);
    if (!this.modal) throw new Error('nie znaleziono modala ' + root.dataset.modalId);
    var m = this.modal;

    this.el = {
      open: root.querySelector('[data-wb-open]'),
      tabs: m.querySelector('[data-wb-tabs]'),
      slider: m.querySelector('[data-wb-slider]'),
      fill: m.querySelector('[data-wb-fill]'),
      thumb: m.querySelector('[data-wb-thumb]'),
      badge: m.querySelector('[data-wb-badge]'),
      min: m.querySelector('[data-wb-min]'),
      max: m.querySelector('[data-wb-max]'),
      price: m.querySelector('[data-wb-price]'),
      monthly: m.querySelector('[data-wb-monthly]'),
      months: m.querySelector('[data-wb-months]'),
      date: m.querySelector('[data-wb-date]'),
      total: m.querySelector('[data-wb-total]'),
      note: m.querySelector('[data-wb-note]'),
      message: m.querySelector('[data-wb-message]'),
      cta: m.querySelector('[data-wb-cta]')
    };

    this.bind();
    this.renderTabs();
    this.renderSlider();
    this.render();
  }

  Kalkulator.prototype.wariant = function () { return this.warianty[this.wariantIdx]; };

  Kalkulator.prototype.months = function () {
    var m = this.wariant().months;
    return m[Math.min(this.monthsIdx, m.length - 1)];
  };

  Kalkulator.prototype.bind = function () {
    var self = this;

    this.el.slider.addEventListener('input', function (e) {
      self.monthsIdx = Number(e.target.value);
      self.renderSlider();
      self.render();
    });

    // Na czas przeciągania wyłączamy przejście, żeby gałka nie odklejała się
    // od palca. Ale dopiero gdy palec naprawdę jedzie: samo wciśnięcie to
    // także zwykłe kliknięcie w tor, a to ma się animować. Wyłączanie już
    // na pointerdown kasowało animację kliknięcia, czyli jedyny przypadek,
    // dla którego to powstało.
    var tor = this.el.slider.parentNode;
    var wcisniety = false;
    var startX = 0;

    this.el.slider.addEventListener('pointerdown', function (e) {
      wcisniety = true;
      startX = e.clientX;
    });

    window.addEventListener('pointermove', function (e) {
      if (!wcisniety) return;
      if (Math.abs(e.clientX - startX) > 3) tor.classList.add('is-dragging');
    });

    ['pointerup', 'pointercancel'].forEach(function (nazwa) {
      window.addEventListener(nazwa, function () {
        wcisniety = false;
        tor.classList.remove('is-dragging');
      });
    });

    // Symulator nie składa wniosku o kredyt — przycisk tylko kupuje produkt.
    // Przy goToCheckout omijamy koszyk i idziemy prosto do finalizacji, gdzie
    // klient wybiera raty jako metodę płatności. Shopify nie pozwala wskazać
    // tej metody z góry, więc dowozimy go tylko pod właściwy ekran.
    this.el.cta.addEventListener('click', function () {
      // Domyślnie przekierowanie. Zwykłe dodanie do koszyka tylko wtedy, gdy
      // ustawienie bloku jawnie je wyłączy — dzięki temu sama podmiana tego
      // pliku wystarcza, bez ruszania sekcji produktu.
      if (self.cfg.goToCheckout === false) {
        var atc = document.querySelector('#product-form-' + self.sectionId + ' [name="add"]');
        if (atc) atc.click();
        if (typeof self.modal.hide === 'function') self.modal.hide();
        return;
      }
      self.doFinalizacji();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event.data;
        if (!d || d.sectionId !== self.sectionId) return;
        self.onVariantChange(d.variant);
      });
    }
  };

  /** Dodaje produkt do koszyka i przenosi prosto do finalizacji zakupu. */
  Kalkulator.prototype.doFinalizacji = function () {
    var self = this;
    var form = document.querySelector('#product-form-' + this.sectionId);
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      // Bez wariantu nie ma czego kupić — niech zadziała zwykła ścieżka motywu.
      var atc = form && form.querySelector('[name="add"]');
      if (atc) atc.click();
      return;
    }

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    // Blokada przed drugim kliknięciem, zanim przeglądarka zdąży przejść dalej.
    if (this.wTrakcie) return;
    this.wTrakcie = true;
    this.el.cta.disabled = true;

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: isNaN(qty) ? 1 : qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        window.location.href = '/checkout';
      })
      .catch(function (e) {
        console.error('[symulator rat] nie udało się dodać do koszyka', e);
        self.wTrakcie = false;
        self.el.cta.disabled = false;
        // Awaryjnie: zwykłe dodanie do koszyka przez motyw.
        var atc = form.querySelector('[name="add"]');
        if (atc) atc.click();
      });
  };

  /** Zmiana wariantu produktu: nowa cena albo ukrycie, gdy się nie kwalifikuje. */
  Kalkulator.prototype.onVariantChange = function (variant) {
    if (!variant || !variant.available ||
        variant.price < this.cfg.minCents || variant.price > this.cfg.maxCents) {
      this.root.hidden = true;
      return;
    }
    this.root.hidden = false;
    this.priceCents = variant.price;
    this.renderSlider();
    this.render();
  };

  Kalkulator.prototype.renderTabs = function () {
    var self = this;
    this.el.tabs.innerHTML = '';
    if (this.warianty.length < 2) return;

    this.warianty.forEach(function (w, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wb-tab';
      btn.textContent = w.label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', String(i === self.wariantIdx));
      btn.addEventListener('click', function () {
        self.wariantIdx = i;
        // Poprzednia pozycja bywa niedostępna w nowym wariancie.
        self.monthsIdx = Math.min(self.monthsIdx, w.months.length - 1);
        self.renderTabs();
        self.renderSlider();
        self.render();
      });
      self.el.tabs.appendChild(btn);
    });
  };

  Kalkulator.prototype.renderSlider = function () {
    var months = this.wariant().months;
    var s = this.el.slider;
    s.min = '0';
    s.max = String(months.length - 1);
    s.value = String(Math.min(this.monthsIdx, months.length - 1));
    s.setAttribute('aria-valuetext', this.months() + ' rat');

    // Gałka wędruje od połowy swojej szerokości do końca toru minus ta połowa,
    // więc samo ratio * 100% kończyłoby wypełnienie obok niej, nie pod nią.
    var ratio = months.length > 1 ? Number(s.value) / (months.length - 1) : 1;
    // Czytamy z samego wypełnienia: modal wędruje do <body>, więc element
    // bloku nie jest już jego przodkiem.
    var thumb = getComputedStyle(this.el.fill).getPropertyValue('--wb-thumb-size').trim() || '32px';
    this.el.fill.style.width = 'calc(' + ratio + ' * (100% - ' + thumb + ') + ' + thumb + ' / 2)';
    // Ta sama droga co wypełnienie, tylko bez połowy gałki na końcu —
    // pozycjonujemy lewą krawędź, nie środek.
    if (this.el.thumb) {
      this.el.thumb.style.left = 'calc(' + ratio + ' * (100% - ' + thumb + '))';
    }

    this.el.badge.textContent = this.months() + ' rat';
    this.el.min.textContent = 'min. ' + months[0] + ' rat';
    this.el.max.textContent = 'max. ' + months[months.length - 1] + ' rat';
  };

  Kalkulator.prototype.render = function () {
    var cena = this.priceCents / 100;
    var months = this.months();
    var w = this.wariant();

    var poza = cena * 100 < this.cfg.minCents || cena * 100 > this.cfg.maxCents;
    var rata = poza ? 0 : monthlyPayment(cena, months, w.rate);
    var doSplaty = w.rate ? roundMoney(rata * months) : cena;

    this.el.price.textContent = formatPLN(cena);
    this.el.months.textContent = months + ' rat';
    this.el.date.textContent = formatDate(addDays(new Date(), this.cfg.firstPaymentDays));

    if (poza) {
      var tpl = cena * 100 < this.cfg.minCents ? this.cfg.belowMin : this.cfg.aboveMax;
      this.el.message.textContent = tpl
        .replace('{min}', formatPLN(this.cfg.minCents / 100))
        .replace('{max}', formatPLN(this.cfg.maxCents / 100));
      this.el.message.hidden = false;
      this.el.monthly.textContent = '—';
      this.el.total.textContent = '—';
      this.el.cta.disabled = true;
    } else {
      this.el.message.hidden = true;
      this.el.monthly.textContent = formatPLN(rata);
      this.el.total.textContent = formatPLN(doSplaty);
      this.el.cta.disabled = false;
    }

    this.el.note.textContent = w.note;
    this.el.note.hidden = !w.note;

    // Przycisk otwierający zawsze pokazuje najniższą ratę 0%.
    var zeroMonths = this.cfg.zeroMonths;
    if (zeroMonths.length) {
      var maxZero = Math.max.apply(null, zeroMonths);
      this.el.open.textContent = this.cfg.openLabel
        .replace('{rata}', formatPLN(cena / maxZero))
        .replace('{rat}', String(maxZero));
    }
  };

  function init() {
    document.querySelectorAll('[data-wb-raty]:not([data-wb-started])').forEach(function (root) {
      root.setAttribute('data-wb-started', '1');
      try {
        new Kalkulator(root);
      } catch (e) {
        console.error('[symulator rat]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Sekcja przeładowuje się w edytorze motywu po każdej zmianie ustawień.
  document.addEventListener('shopify:section:load', init);
})();